export const environment = {
    production: false,
    development: false,
    staging: true,
    host: 'https://stage.se2.tech',
    creatoradminApi: 'https://stage.creatoradmin.spooorts.de/',
    loginApi: 'https://stage.login.spooorts.de/login/',
    // Stripe endpoints live here — see stripe-backend.instructions.md
    backofficeApi: 'https://stage.backoffice.spooorts.de',
    // Stripe sandbox publishable key — fill in your pk_test_... from Stripe Dashboard
    stripePublishableKey: 'pk_test_51TOfqQEXS8bUsCDLbdgPDkhPLuq2zbrsGWCIDqcCViyK9nNCLDrCTOwSTbjlddaIV0QUglawuPhsVenQsATv5qAP00HEqr5iO2',
};